/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';

const propTypes = {
  created_at: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  isMine: PropTypes.bool.isRequired,
};

const Message = ({
  created_at: createdAt, message, isMine,
}) => (
  <div className={classnames(['live-chat__message', isMine && 'mine'])}>
    <div className="live-chat__message--cloud">
      <p
        className="live-chat__message--text"
        dangerouslySetInnerHTML={{
          __html: message,
        }}
      />
      <div className="live-chat__message--created-at">
        {moment(createdAt).format('h:mm A')}
      </div>
    </div>
  </div>
);

Message.propTypes = propTypes;

export default Message;
